import { v4 as uuidv4 } from 'uuid';

let inMemoryUuid = uuidv4();

/**
 * Session id handed over by the native app when the funnel runs inside its
 * WebView. Kept in sync with `saas-app` `src/utils/riskifiedWebViewBridge.ts`,
 * which sets it before this bundle evaluates.
 */
const NATIVE_SESSION_ID_GLOBAL = '__RN_RISKIFIED_SESSION_ID__';

/**
 * Reads the id the native app published on `window`, if any.
 *
 * MOB-347: without this the app and the funnel each minted their own id, so a
 * purchase made through the WebView produced two antifraud sessions — the native
 * beacon stayed attached to no purchase at all, because the funnel sent its own
 * `riskified_beacon_id` at checkout.
 */
function getNativeSessionId() {
  if (typeof window === 'undefined') return null;

  const nativeSessionId = window[NATIVE_SESSION_ID_GLOBAL];

  return typeof nativeSessionId === 'string' && nativeSessionId ? nativeSessionId : null;
}

// if the browser doesn't support sessionStorage
// the id stored in memory is used
export function setInitialSessionId() {
  const nativeSessionId = getNativeSessionId();

  if (!window.sessionStorage) {
    // Still adopt it, so the in-memory fallback matches the native session too.
    if (nativeSessionId) inMemoryUuid = nativeSessionId;
    return;
  }

  // The native id wins even over a stored one: inside the WebView the app owns
  // the session, and a stale value from an earlier visit would split it again.
  if (nativeSessionId) {
    window.sessionStorage.setItem('reservamos.sessionId', nativeSessionId);
  } else if (!window.sessionStorage.getItem('reservamos.sessionId')) {
    window.sessionStorage.setItem('reservamos.sessionId', uuidv4());
  }

  return window.sessionStorage.getItem('reservamos.sessionId');
}

// returns the id stored in memory if the browser
// doesn't support sessionStorage
export function getSessionId() {
  if (!window.sessionStorage) return inMemoryUuid;

  return window.sessionStorage.getItem('reservamos.sessionId');
}

// if the browser doesn't support sessionStorage
// the id stored in memory is reset
export function resetSessionId() {
  const newId = uuidv4();

  if (window.sessionStorage) {
    window.sessionStorage.setItem('reservamos.sessionId', newId);
  } else {
    inMemoryUuid = newId;
  }

  return newId;
}

/**
 * This method triggers the execution of the sign out method
 * that is provided by the siempreplus widget.
 */
export function triggerSignOutWidget(loyaltyWidgetName) {
  window.reservamosPubSub.pub(`${loyaltyWidgetName}-signOut`);
}

/**
 * This method triggers the execution of the sign in method
 * provided by the siempreplus widget.
 */
export function triggerSignInWidget(loyaltyWidgetName) {
  window.reservamosPubSub.pub(`${loyaltyWidgetName}-signIn`);
}
